<template>
    <div class="media">
        <multiselect
            :value="fontAwesomeIconKeys.find(key => key === value)"
            :options="fontAwesomeIconKeys"
            @select="onIconSelect"
            placeholder="Search icon"
            :disabled="disabled"
            :optionsLimit="100"
            :maxHeight="150"
            class="multiselect-md media-body"
            :show-labels="false">
            <template v-slot:singleLabel="{ option }">
                <div class="d-inline-block">
                    <i class="fal" :class="`fa-${option}`"></i>
                </div>
                <div class="d-inline-block pl-2 align-top">
                    {{ option }}
                </div>
            </template>
            <template v-slot:option="{ option }">
                <div class="d-inline-block">
                    <i class="fal" :class="`fa-${option}`"></i>
                </div>
                <div class="d-inline-block pl-2 align-top">
                    {{ option }}
                </div>
            </template>
        </multiselect>
        <a class="view-fontawesome-icons-btn"
           href="https://fontawesome.com/search"
           v-tooltip="'View all icons in original source'"
           target="_blank">
            <i class="fal fa-arrow-up-right-from-square"></i>
        </a>
    </div>
</template>

<script>
import {fontAwesomeIconKeys} from '@/components/shared/icon-picker/fontawesome-icons'

export default {
    name: 'AppIconSelect',
    props: {
        value: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: '#475b62'
        }
    },
    data() {
        return {
            fontAwesomeIconKeys
        }
    },
    model: {
        prop: 'value',
        event: 'input'
    },
    methods: {
        onIconSelect(icon) {
            this.$emit('input', icon)
        }
    }
}
</script>

<style lang="scss" scoped>
.view-fontawesome-icons-btn {
    display: block;
    height: 38px;
    line-height: 38px;
    width: 38px;
    vertical-align: middle;
    text-align: center;
    margin-left: 4px;
    border: 1px solid rgb(206, 212, 218);
    border-radius: 4px;

    &:hover {
        cursor: pointer;
        background: $color-purple-soft;
    }
}
</style>
